var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormatFunctionOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9.93331L15.7117 8.96188L13.4597 11.9838L11.4483 9.28564H8.09872L9.27182 3.68224C9.28704 3.60933 9.43669 3.61096 9.43669 3.7V4.02376H11.0459V3.7C11.0459 2.76257 10.288 2 9.34979 2C8.55493 2 7.85976 2.56742 7.69638 3.34952L6.45487 9.28563H4.60911V10.9047H6.11611L4.77411 17.3179C4.75794 17.3907 4.6091 17.389 4.6091 17.3008V16.9762H3V17.3008C3 18.2382 3.75714 19 4.69531 19C5.49017 19 6.18614 18.4326 6.34872 17.6506L7.75996 10.9047H10.6436L12.3324 13.1713L12.4539 13.3333L9.91866 16.7333L11.2069 17.7055L13.4597 14.6827L15.7118 17.7055L17 16.7333L14.4655 13.3333L17 9.93331Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatFunctionOutlined);
export default __webpack_public_path__ + "static/media/format_function_outlined.7a8309d3.svg";
export { ForwardRef as ReactComponent };